import React from "react";
import {Checkbox} from "@progress/kendo-react-inputs";
import {DropDownList} from "@progress/kendo-react-dropdowns";
import {CRITERIA, FIT_VALUES, IMPORTANCE_VALUES, supportsDemographicSelection, validateDemographicForm} from "./DemographicSelectionProfile";

export default function DemographicSelectionForm({value, onChange, pipelineType, fileType, showErrors, idPrefix}) {
    const supported = supportsDemographicSelection(pipelineType, fileType);
    const errors = validateDemographicForm(value, supported);
    if (value.loadError || (!supported && errors.profile)) {
        return <div className="ip-test-msg error" role="alert">{errors.profile}</div>;
    }
    if (!supported) return null;
    const updateCriterion = (name, changes) => onChange({...value, [name]: {...value[name], ...changes}});
    const dropdown = (name, key, label, options, selected, onSelect) => {
        const id = `${idPrefix}-${name}-${key}`;
        const error = showErrors && errors[`${name}.${key}`];
        return <div className={`ip-field${error ? " ip-error" : ""}`} key={key}>
            <label id={`${id}-label`} htmlFor={id}>{label}</label>
            <DropDownList id={id} ariaLabelledBy={`${id}-label`} ariaDescribedBy={error ? `${id}-error` : undefined}
                data={options} value={selected || null} defaultItem={key === "importance" ? "Select importance..." : "Select fit..."}
                onChange={e => onSelect(options.includes(e.value) ? e.value : "")}/>
            {error && <div id={`${id}-error`} className="ip-test-msg error">{error}</div>}
        </div>;
    };
    return <section className="ip-section" aria-labelledby={`${idPrefix}-title`}>
        <div className="ip-section-title" id={`${idPrefix}-title`}>Demographic Person Selection</div>
        <div className="additional-option">
            <Checkbox label="Enable demographic person selection" checked={value.enabled}
                onChange={e => onChange({...value, enabled: e.value, clearRequested: !e.value})}/>
        </div>
        {value.enabled && <>
            <p className="k-form-hint">Choose preferences for ranking people within the matched household. Mismatch means zero preference, not exclusion. The ranking score is not a probability.</p>
            {showErrors && errors.profile && <div className="ip-test-msg error" role="alert">{errors.profile}</div>}
            {Object.entries(CRITERIA).map(([name, keys]) => <div className="ip-section" key={name}>
                <div className="additional-option">
                    <Checkbox label={name === "age" ? "Age" : "Gender"} checked={value[name].enabled}
                        onChange={e => updateCriterion(name, {enabled: e.value})}/>
                </div>
                {value[name].enabled && <>
                    {dropdown(name, "importance", `${name === "age" ? "Age" : "Gender"} importance`, IMPORTANCE_VALUES,
                        value[name].importance, importance => updateCriterion(name, {importance}))}
                    <div className="ip-two-col">
                        {keys.map(key => dropdown(name, key, `${key} fit`, FIT_VALUES, value[name].fits[key],
                            fit => updateCriterion(name, {fits: {...value[name].fits, [key]: fit}})))}
                    </div>
                </>}
                <p className="k-form-hint">{name === "age"
                    ? "Missing age (NULL) is handled as Unknown automatically, with a fixed fit of 0.25."
                    : "Stored gender Unknown is handled automatically, with a fixed fit of 0.25."}</p>
            </div>)}
        </>}
    </section>;
}
